<template>
  <div class="qihuo-contract">
    <p class="qihuo-contract-header">商务合作</p>
    <div class="qihuo-contract-body">
      <!-- <div>
        <img src="~@/assets/img/commons/gift.jpg"/> 
         
      </div> -->
      <div>
        <img src="~@/assets/img/commons/cooperation.jpg"/>  
      </div>
      <div>
        <img src="~@/assets/img/commons/accessData.jpg"/>
      </div>
    </div>
  </div>
</template>
<script>
export default {}
</script>
<style lang="scss" scoped>
$pr: 'qihuo-contract';
$img2x: 'screen and (-webkit-min-device-pixel-ratio: 2), not all, not all, screen and (min-resolution: 2dppx)';

.#{$pr} {
  //position: absolute;
  //left: 0px;
  //bottom: -152px - 30px;
  width: 100%;
  margin-bottom: 20px;
  //height: 170px;
  background: #ffffff;
  box-shadow: 3px 3px 5px 0px rgba(0, 0, 0, 0.06);
  border-radius: 2px;
  border: 1px solid #f4f4f4;
  padding: 19px 27px 30px 27px;
  //top: 480px;

  &-header {
    font-size: 19px;
    //font-family: PingFangSC-Medium, PingFang SC;
    font-weight: bold;
    color: #555555;
    line-height: 26px;
  }
  &-body {
    margin-top: 30px;
    //background-image: url('../assets/img/commons/contract_bg.png');
    //height: 67px;
    background-size: 100% 100%;
    //padding-left: 79px;
    //padding-top: 17px;
    @media #{$img2x} {
      //background-image: url('../assets/img/commons/contract_bg@2x.png');
    }
    &>div{

    }
    & > div {
      vertical-align: middle;
      margin-bottom: 17px;
      &:last-child{
         margin-bottom: 0px;
      }
    }
  }
  &-title {
    font-size: 14px;
    //font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #555555;
    line-height: 20px;
  }
  &-value {
    font-size: 14px;
    //font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #978a7a;
    line-height: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// Contact.vue?c920cc26